import React, { useEffect, useState } from "react";
import { Container, Row, Col } from "reactstrap";
import { useTranslation } from "react-i18next";

const News = () => {
  const { t, i18n } = useTranslation();
  const [newsItems, setNewsItems] = useState([]);

  useEffect(() => {
    const lang = i18n.language || "es";
    fetch(`/data/news_${lang}.json`)
      .then((res) => res.json())
      .then((data) => setNewsItems(data))
      .catch((err) => console.error("Error loading news:", err));
  }, [i18n.language]);

  return (
    <section className="section bg-light">
      <Container>
        <h3 className="text-center mb-5">{t("NOTICIAS DEL CONGRESO")}</h3>
        <Row>
          {newsItems.map((item) => (
            <Col lg={12} className="mb-4" key={item.id}>
              <div className="p-4 bg-white shadow-sm rounded">
                <h4 className="fw-bold mb-2">{item.title}</h4>
                <p className="text-muted small mb-3">{item.date}</p>
                <div
                  className="text-muted"
                  style={{ textAlign: "justify" }}
                  dangerouslySetInnerHTML={{ __html: item.content }}
                ></div>

              </div>
            </Col>
          ))}
        </Row>

      </Container>
    </section>
  );
};

export default News;